var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneIphone = function SvgPhoneIphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M661.33 42.68H319.99c-58.88 0-106.67 47.79-106.67 106.67v725.32c0 58.88 47.79 106.66 106.67 106.66h341.33c58.88 0 106.66-47.78 106.66-106.66V149.34c0-58.88-47.78-106.67-106.66-106.67Zm-170.67 896c-35.41 0-64-28.58-64-64s28.59-64 64-64 64 28.58 64 64-28.59 64-64 64m192-170.66h-384V170.68h384v597.33Z"
  })));
};
export default SvgPhoneIphone;